module.exports = __webpack_public_path__ + "images/avatars/male/7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/7.png
// module id = ZawD
// module chunks = 55